import actionTypes from '../actionTypes';

const initialState = {
  isConnected: false,
  microPhoneState: "",
  isMinimize: false,
  onCall: false,
  isWidgetOpen: false,
  isDuplicatePage: false,
  isDuplicateProcess: false,
  breakList: [],
  custInfo: {},
  selectedTab: 'online',
  phoneType: '', // pstn or web
  bridgeState: '', // pstn or web
  bridgeStateOTP: '', // pstn or web
  state: {},
  isOffline: false,
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GLOBAL_SOCKET_STATE:
      newState.isConnected = action.payload.isConnected;
      return newState;
    case actionTypes.IS_OFFLINE:
      newState.isOffline = action.payload.isOffline;
      return newState;
    case actionTypes.GLOBAL_MINIMIZE_APP:
      newState.isMinimize = action.payload.data;
      return newState;
    case actionTypes.GLOBAL_DYNAMIC_UPDATE:
      if ( action.payload.data ) {
        if (Array.isArray(action.payload.data)) {
          action.payload.data.forEach((item) => {
            if (item.key) newState[item.key] = item.value
          });
        } else {
          if (action.payload.data.key)
            newState[action.payload.data.key] = action.payload.data.value;
        }
        // console.log("Dyna")
      }
      return newState;
    case actionTypes.GLOBAL_CALL_STATE:
      newState.onCall = action.payload.data;
      return newState;
    case actionTypes.GLOBAL_TAB_STATE:
      newState.selectedTab = action.payload.data;
      return newState;
    case actionTypes.GLOBAL_STATE:
      newState.state = action.payload.data;
      return newState;
    case actionTypes.SET_BREAK_LIST:
        newState.breakList = action.payload.data;
      return newState;


    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/store/reducers/globalState.reducer.js